import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiDangNhap(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(ENDPOINT.AUTH.DANG_NHAP, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiRefreshToken(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(ENDPOINT.AUTH.REFRESH_TOKEN, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetPermission(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.GET_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiSyncData() {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.APP.SYNC_DATA)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC.TINH_THANH,
    method: "GET",
    params: payload
  });
}

export function callApiLayDanhSachLevel() {
  return HTTP({
    url: ENDPOINT.DANH_MUC.LEVEL,
    method: "GET"
  });
}


export function callApiChangeGenerateSetupCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.GENERATE_SETUP_CODE_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}

export function callApiConfirmUsing(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.CONFIRM_USING_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}

// P2 QR handoff: mint enroll-ticket (token stage-1) -> {ticketId, expiresInSeconds}.
export function callApiMintEnrollTicket() {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.MINT_ENROLL_TICKET, {})
        .then(response => { resolve(response); })
        .catch(error => { reject(error); });
  });
}

// P2 QR handoff: poll pending enroll -> {hasPending, deviceId, tenThietBi}.
export function callApiGetPendingEnroll() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.GET_PENDING_ENROLL)
        .then(response => { resolve(response); })
        .catch(error => { reject(error); });
  });
}

// P2 QR handoff: confirm-enroll-binding (channel-binding CRIT-2) -> Device Active.
export function callApiConfirmEnrollBinding(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.CONFIRM_ENROLL_BINDING, payload)
        .then(response => { resolve(response); })
        .catch(error => { reject(error); });
  });
}

// UC7.4 port QTHT: mint-add-device-ticket (Bearer, gate OTP thiết bị đang dùng) -> {ticketId, expiresInSeconds}.
// Body camelCase theo convention common-fe (authorizerDeviceId null -> BE fan-out verify mọi thiết bị Active).
export function callApiMintAddDeviceTicket(authorizerOtp, authorizerDeviceId) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.MINT_ADD_DEVICE_TICKET, { authorizerOtp, authorizerDeviceId })
        .then(response => { resolve(response); })
        .catch(error => { reject(error); });
  });
}

export function callApiValidateLogin(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.VALIDATE_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}

// Phase 5b-2: provisioning thiết bị 2FA. Dùng HTTP client mặc định (Bearer ACCESS_TOKEN) — BE dual-scheme
// "2FA,Bearer" chấp nhận cả token đầy đủ (màn quản lý post-login) lẫn token giai đoạn 2FA (trong login).
export function callApiRegisterDevice(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.REGISTER_DEVICE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiConfirmDevice(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.CONFIRM_DEVICE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiListDevice() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.LIST_DEVICE)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// GAP 7.4: đặt 1 thiết bị Active của CHÍNH user hiện tại làm primary. Body { deviceId } (camelCase over-the-wire).
export function callApiSetPrimary(deviceId) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.SET_PRIMARY, { deviceId })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 10 UC12: admin khoá/mở + xem thiết bị OTP của user khác. Bearer ACCESS_TOKEN đầy đủ
// (BE role "reset-setting-2fa"). Payload lock/unlock: { userId, deviceId, twoFactorCode, adminDeviceId }.
export function callApiLockDevice(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.LOCK_DEVICE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiUnlockDevice(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.UNLOCK_DEVICE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiListDeviceByUser(userId) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.LIST_DEVICE_BY_USER, { params: { userId } })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// UC7.5: hủy 1 thiết bị (soft-state DaHuyKichHoat). Payload: { userId, deviceId, twoFactorCode, authorizerDeviceId }.
export function callApiRevokeDevice(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.REVOKE_DEVICE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// UC10.4: kích hoạt lại tài khoản đã vô hiệu (atomic). Payload: { userId, twoFactorCode, deviceId, reason }.
export function callApiReactivate2Fa(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.REACTIVATE_2FA, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// OFF 2FA per-user (Approach A - 2026-08-11): admin vô hiệu 2FA của user khác (step-up OTP admin).
// Payload: { userId (target), twoFactorCode (OTP admin), deviceId (null -> BE fan-out), reason (BAT BUOC) }.
export function callApiDisable2Fa(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.DISABLE_2FA, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Đối xứng callApiDisable2Fa: bật lại 2FA cho user (clear exempt + revoke phiên).
export function callApiEnable2Fa(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.ENABLE_2FA, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 7B-1 UC13: cấu hình bảo mật OTP (admin). GET đọc config, PUT lưu (BE validate + reload live).
export function callApiGetOtpConfig() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.OTP_CONFIG)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiUpdateOtpConfig(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.AUTH.OTP_CONFIG, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 7C UC11: admin cấp mã kích hoạt (gửi email tới user) + user verify mã.
export function callApiIssueActivation(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.OTP_ACTIVATION_ISSUE, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiVerifyActivation(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.OTP_ACTIVATION_VERIFY, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 9b UC6: user tự yêu cầu cấp mã (self-service) - không body, gửi tới email đã xác nhận của current user.
export function callApiRequestActivation() {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.OTP_ACTIVATION_REQUEST, {})
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 07 (Push Approval login-web): poll trạng thái attempt duyệt qua app QLVB.
// Header Bearer PHẢI là token stage-1 (KHÔNG prefix "2FA" — verify LIVE Phase 04) — truyền tường minh,
// không dựa vào HTTP.defaults.headers (tránh lệ thuộc thứ tự side-effect ở caller).
export function callApiPollLoginApproval(loginAttemptId, pollSecret, stage1Token) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.POLL_LOGIN_APPROVAL, {
      params: { loginAttemptId, pollSecret },
      headers: { Authorization: `Bearer ${stage1Token}` },
    })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 07: mint token 24h đầy đủ sau khi attempt được duyệt qua app (RT-1).
export function callApiCompleteLogin(payload, stage1Token) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.COMPLETE_LOGIN, payload, {
      headers: { Authorization: `Bearer ${stage1Token}` },
    })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// Phase 8 UC17: nhật ký OTP. Search (paged) + export (blob .xlsx).
export function callApiSearchOtpAudit(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.OTP_AUDIT_SEARCH, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// GAP 17.1 INFO: lấy catalog Reason/Group/Prefix từ BE (single source of truth).
// FE fallback cứng vẫn giữ - endpoint fail không phá đường cũ.
export function callApiGetOtpReasonCatalog() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.OTP_AUDIT_REASON_CATALOG)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiExportOtpAudit(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.OTP_AUDIT_EXPORT, payload, { responseType: "blob" })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// UC14 Phase 2: cau hinh step-up theo chuc nang. GET tra flat bool {kySo, pheDuyet, thuHoi, capQuyen}
// (KHONG phai mang policies[]). PUT nhan tung field optional (null = giu nguyen).
export function callApiGetStepUpPolicies() {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.STEP_UP_POLICIES)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

export function callApiUpdateStepUpPolicies(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.put(ENDPOINT.AUTH.STEP_UP_POLICIES, payload)
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}

// GET query pageIndex/pageSize (paging). Res PagedResult.Items = [{ id, actionType, enabled, changedBy, changedByName, createdAt }].
export function callApiSearchStepUpPolicyHistory(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.STEP_UP_POLICY_HISTORY, { params: payload })
        .then(response => resolve(response))
        .catch(error => reject(error));
  });
}
